import { render } from "./EditProposalImportance.vue?vue&type=template&id=25182ada&scoped=true"
import script from "./EditProposalImportance.vue?vue&type=script&lang=js"
export * from "./EditProposalImportance.vue?vue&type=script&lang=js"

import "./EditProposalImportance.vue?vue&type=style&index=0&id=25182ada&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25182ada"]])

export default __exports__